import * as React from 'react'

/**
 * Memoized id → channel lookup for a list of channels. Built once per list and
 * shared by render (resolving each card's channel) and the mention coordination
 * adapter (channel-level repliability), so `channels` is only mapped once.
 *
 * Generic over the channel shape so callers keep their own (fragment-derived)
 * channel type in the map values rather than widening to the codegen `Channel`.
 *
 * Iteration order follows `channels`, so callers can derive channel ids in
 * stable order from `map.keys()`.
 */
export const useChannelMap = <TChannel extends { id: string }>(
  channels: readonly TChannel[],
): Map<string, TChannel> =>
  React.useMemo(
    () => new Map(channels.map((channel) => [channel.id, channel])),
    [channels],
  )
